import { render, staticRenderFns } from "./category-levels-assessment-mobile-placeholder.vue?vue&type=template&id=7f3ac037&scoped=true&"
import script from "./category-levels-assessment-mobile-placeholder.vue?vue&type=script&lang=ts&"
export * from "./category-levels-assessment-mobile-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./category-levels-assessment-mobile-placeholder.vue?vue&type=style&index=0&id=7f3ac037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3ac037",
  null
  
)

export default component.exports